import * as React from 'react';
import { SVGProps } from 'react';

const CardPlusIcon: React.FC<SVGProps<SVGSVGElement>> = props => (
  <svg {...props} viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg">
    <g strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
      <path d="M25.375 16.917v-7.25a6.042 6.042 0 0 0-6.042-6.042H9.667a6.042 6.042 0 0 0-6.042 6.042v9.666a6.042 6.042 0 0 0 6.042 6.042h7.25M25.376 16.917v2.417a6.042 6.042 0 0 1-6.041 6.041h-2.417" />
      <path d="M18.125 25.375v-1.208a6.042 6.042 0 0 1 6.042-6.042h1.208M12.082 14.5h4.833M14.5 16.916v-4.833" />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h29v29H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default CardPlusIcon;
